const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    title: {
      type: 'string',
      title: 'عنوان',
    },
    category_id: {
      type: 'string',
      title: 'دسته',
    },
    details: {
      type: 'string',
      title: 'توضیحات',

    },
    type: {
      type: 'string',
      title: 'activity',
      oneOf: [
        { const: 'SINGLE_SELECTION', title: 'Single Selection' },
        { const: 'MULTIPLE_SELECTION', title: 'Multiple Selection' },
      ],
    },
  },
});

export default schema;
